/* models/textures/texture */ function _(require, module, exports) {
    var tslib_1 = require(426) /* tslib */;
    var model_1 = require(62) /* ../../model */;
    var p = require(18) /* ../../core/properties */;
    var Texture = /** @class */ (function (_super) {
        tslib_1.__extends(Texture, _super);
        function Texture(attrs) {
            return _super.call(this, attrs) || this;
        }
        Texture.initClass = function () {
            this.define({
                repetition: [p.TextureRepetition, "repeat"],
            });
        };
        Texture.prototype.onload = function (defer_func) {
            defer_func();
        };
        Texture.__name__ = "Texture";
        return Texture;
    }(model_1.Model));
    exports.Texture = Texture;
    Texture.initClass();
}
